import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Java",
    "HTML",
    "CSS",
    "JavaScript",
    "SQL",
    "Git",
    "GitHub",
    "Problem Solving",
    "OOP"
];

const labelsSecond = [
    "Data Structures",
    "Algorithms",
    "Software Development",
    "Debugging",
    "Team Collaboration",
    "Learning Agility",
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Qdrant",
    "Hugging Face",
    "LlamaIndex",
    "Streamlit",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x" color="skyblue" className="react-icon"/>
                    <h3>Java & Web Development</h3>
                    <p>I am building a strong foundation in Java, web technologies, and object-oriented programming. I enjoy creating practical applications and improving my coding and problem-solving skills every day.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x" className="docker-icon"/>
                    <h3>Projects & Learning</h3>
                    <p>I work on small but meaningful projects such as library systems, result management tools, and portfolio websites to strengthen my development skills and showcase my progress.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x" className="python-icon"/>
                    <h3>Analytical Thinking</h3>
                    <p>I use structured thinking, debugging, and hands-on practice to solve coding problems and build reliable solutions. Continuous learning is a big part of my growth as a developer.</p>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;